<form [formGroup]="mainForm" (ngSubmit)="onSubmit()" novalidate (keydown.enter)="$event.preventDefault()">
  <div class="container" [ngClass]="{'style-25': usaTema == '25', 'style-25b': usaTema == '25b'}">
    <div class="row">
      <div class="col">
        <h1 i18n="@@FormTitle">Richiesta certificati Robur</h1>
        <mat-card>
          <mat-card-content i18n="@@FormDescription">
            <p>
              Gentile Cliente,</p>
            <p>Con questo form puoi richiedere la certificazione di qualità dei nostri prodotti dotati di numero di lotto. Tutti
              i campi sono obbligatori per permettere al nostro sistema di individuare univocamente la documentazione. Il
              tipo di certificato può variare a seconda del prodotto. </p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="row" style="margin-top: 10px">
      <mat-form-field class="formField col">
        <input matInput placeholder="Nome" type="text" i18n-placeholder="@@FormNamePlaceholder" formControlName="name" required>
        <!-- <mat-hint>Nome del richiedente</mat-hint> -->
        <mat-error *ngIf="mainForm.get('name').hasError('required')" i18n="@@FormNameRequired">
          Il nome è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="formField col">
        <input matInput placeholder="Cognome" type="text" i18n-placeholder="@@FormSurnamePlaceholder" formControlName="surname" required>
        <!-- <mat-hint>Nome del richiedente</mat-hint> -->
        <mat-error *ngIf="mainForm.get('surname').hasError('required')" i18n="@@FormSurnameRequired">
          Il cognome è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="formField col">
        <input matInput placeholder="Società" type="text" i18n-placeholder="@@FormCompanyPlaceholder" formControlName="company">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="formField col">
        <input matInput placeholder="E-Mail" type="text" i18n-placeholder="@@FormMailPlaceholder" formControlName="email" required>
        <!-- <mat-hint>Nome del richiedente</mat-hint> -->
        <mat-error *ngIf="mainForm.get('email').hasError('required')" i18n="@@FormMailRequired">
          L'indirizzo e-mail è
          <strong>obbligatorio</strong>
        </mat-error>
        <mat-error *ngIf="!mainForm.get('email').hasError('required') && mainForm.get('email').hasError('email')" i18n="@@FormMailInvalid">
          L'indirizzo e-mail
          <strong>non è valido</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="formField col">
        <input matInput placeholder="Telefono" type="text" i18n-placeholder="@@FormPhonePlaceholder" formControlName="phone" required>
        <!-- <mat-hint>Nome del richiedente</mat-hint> -->
        <mat-error *ngIf="mainForm.get('phone').hasError('required')" i18n="@@FormPhoneRequired">
          Il telefono è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row align-items-center">
      <mat-form-field class="formField col-sm-3">
        <input matInput placeholder="Referenza (9 cifre)" type="text" i18n-placeholder="@@FormProductCodePlaceholder" formControlName="productCode"
          required>
        <mat-hint i18n="@@FormProductCodeHint">Il codice a 9 cifre presente nella sezione catalogo.</mat-hint>
        <mat-error *ngIf="mainForm.get('productCode').hasError('required')" i18n="@@FormProductCodeRequired">
          Il numero di referenza è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
      <div class="col-sm-1"></div>
      <mat-form-field class="formField col-sm-3">
        <input matInput placeholder="Codice lotto" type="text" i18n-placeholder="@@FormBatchCodePlaceholder" formControlName="batchCode"
          required>
        <mat-hint i18n="@@FormBatchCodeHint">Il codice marcato sul prodotto in Vostro possesso.</mat-hint>
        <mat-error *ngIf="mainForm.get('batchCode').hasError('required')" i18n="@@FormBatchCodeRequired">
          Il codice lotto è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
      <mat-icon i18n-matTooltip="@@FormBatchCodeTooltip" style="padding-left: 0" class="col-sm-1" [matTooltipPosition]="'left'"
        matTooltip="Il codice marcato sul prodotto in Vostro possesso (verificare come leggere la marcatura sulla specifica prodotto nella sezione “Download”)">info</mat-icon>
      <mat-form-field class="formField col-sm-3">
        <mat-select placeholder="Lingua certificato" i18n-placeholder="@@FormLanguagePlaceholder" formControlName="language">
          <mat-option [value]="'IT'" i18n="@@FormLanguageItalian">
            Italiano / Inglese
          </mat-option>
          <mat-option [value]="'FR'" i18n="@@FormLanguageFrench">
            Francese / Inglese
          </mat-option>
          <mat-option [value]="'DE'" i18n="@@FormLanguageGerman">
            Tedesco / Inglese
          </mat-option>
        </mat-select>
        <mat-hint i18n="@@FormLanguageHint">Lingua del certificato.</mat-hint>
      </mat-form-field>
      <mat-icon class="col-sm-1" style="padding-left: 0" i18n-matTooltip="@@FormLanguageTooltip" [matTooltipPosition]="'left'"
        matTooltip="La richiesta in lingua non è supportata da tutti i certificati. Se la lingua non viene trovata verrà inviato il certificato nella lingua di default">info</mat-icon>
    </div>
    <div class="row" style="margin-top: 20px">
      <mat-checkbox class="formField col" formControlName="canContact" i18n="@@FormCanContactText">Ho preso visione della
        <a href="https://www.beta-tools.com/{{locale}}/privacy-policy/" target="_blank">privacy policy</a>
        e autorizzo il trattamento secondo l’articolo 2B *</mat-checkbox>
    </div>
    <!--
    <div class="row" style="margin-bottom: 10px">
      <div class="col">
        <recaptcha formControlName="recaptcha" (scriptLoad)="onScriptLoad()" (scriptError)="onScriptError()"></recaptcha>
      </div>
    </div>-->
    <div class="formField row" style="text-align: right">
      <div class="col">
        <!--<button mat-raised-button type="button" (click)="testData()" *ngIf="!isProduction">Test data</button>&nbsp;
        <button mat-raised-button type="submit" color="primary" [disabled]="!mainForm.valid" i18n="@@FormSubmitButton">
          Invia richiesta
        </button>-->
        <button *ngIf="usaTema == ''" mat-raised-button type="submit" color="primary" [disabled]="!mainForm.valid" i18n="@@FormSubmitButton">Invia richiesta</button>
        <div  *ngIf="usaTema != ''" class="btn-box">
          <button type="submit" [disabled]="!mainForm.valid" class="submit-btn" [ngClass]="{'btn-disabled': mainForm.valid == false}"  >
              <span i18n="@@FormSubmitButton">Invia richiesta</span>
              <svg height="25px" width="25px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-72.67 -72.67 372.44 372.44"
                  xml:space="preserve" fill="#000000" stroke="#000000" stroke-width="6.81288" [ngClass]="{'svg-white': mainForm.valid == true}">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                      <g>
                          <g>
                              <polygon style="fill:#010002;"
                                  points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 146.933,181.902 152.835,187.811 227.096,113.55 ">
                              </polygon>
                          </g>
                      </g>
                  </g>
              </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<app-busy-spinner *ngIf="isLoading"></app-busy-spinner>



// WEBPACK FOOTER //
// ./src/app/app.component.html